// Copy shown when an account is signed in — or signs in — but has nothing to
// sign in to. Both cases come from the same event: purging a workspace deletes
// its data and strips its role entries, but the Firebase Auth account survives,
// because an account is a global identity that may hold access in other
// workspaces or be a system admin.
//
// Kept in one place because three screens have to agree: the login form
// (Firebase refuses a disabled account outright), AuthContext's post-login
// routing (signed in, zero access), and the subscriber picker's empty state.
// They previously said three different things, one of which was an internal
// error string.

// Firebase Auth itself rejects the credentials with `auth/user-disabled`, so
// this is shown against a login form that never produced a session.
export const ACCOUNT_DISABLED_MESSAGE =
  'This account has been deactivated. The workspace it belonged to was removed. ' +
  'If you think this is a mistake, contact your administrator or support@traklog.app.';

// The account is *not* disabled — a system admin is deliberately exempt from
// the purge's deactivation, a role can be removed by hand rather than by a
// purge, and the deactivation step is best-effort — so sign-in succeeds and
// the app has to end the session itself.
export const NO_WORKSPACE_MESSAGE =
  'Your account is no longer attached to any workspace.';
